export const LOADER_DURATION = 2000;